import { Fragment, useEffect, useState, useRef } from 'react'
import PageLayout from '../Layouts/PageLayout'
import Spinner from '../FieldComponets/Spinner';
import { useDispatch, useSelector } from 'react-redux';
import { PAGES } from '../../Constants/CommonConstants';
import { MaterialReactTable } from 'material-react-table'
import { paginationQuery, handleSearch } from '../../utils/GlobalHelper';
import type { ColumnFiltersState, PaginationState } from '@tanstack/react-table';
import React from 'react';
import { getDate, getDateFormatData, getStatus } from '../../utils/Helper';
import { useNavigate } from 'react-router-dom';
import ToastDefault from '../FieldComponets/Toast';
import { DashboardRedirectionAction } from '../../Redux/Action/CommonAction';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from 'moment';
import { LinkButtons } from "../FieldComponets/LinkButtons";
import { BookingGetAction } from '../../Redux/Action/BokkingAction';
import { useIntl, FormattedMessage } from 'react-intl';


function BookingMangementList() {

  const intl = useIntl();
  const dispatch = useDispatch<any>();
  const navigate = useNavigate();
  const formRef = useRef<HTMLFormElement>(null);
  const bookinglist = useSelector((state: any) => state.BookingGetState);
  const DashboardRedirectionStatedata = useSelector((state: any) => state.DashboardRedirectionState)
  const [data, setData] = useState<any>([]);
  const [isError, setIsError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [columnFilters, setColumnFilters] = useState<ColumnFiltersState>([]);
  const [openSerach, setOpenSerach] = useState(false)
  const [sorting, setSorting] = useState<any>(['ASC']);

  const [pagination, setPagination] = useState<PaginationState>({
    pageIndex: PAGES?.pageIndex,
    pageSize: PAGES?.pageSize
  });
  const [searchOther, setSearchOther] = useState<any>('');
  const [searchValue, setSearchValue] = useState<any>('');

  const [rowCount, setRowCount] = useState(0);
  const [startDate, setStartDate] = useState('')
  const [endDate, setEndDate] = useState('')


  const columns: any = [
    {
      accessorKey: 'S.NO',
      header: intl.formatMessage({ id: 's_no' }),
      accessorFn: (row: Object, index: number) => {
        const currentPage = pagination.pageIndex + 1 || 1; // Assuming current page number, default to 1 if not provided
        const itemsPerPage = pagination.pageSize || 10; // Assuming items per page, default to 10 if not provided
        const startIndex = (currentPage - 1) * itemsPerPage;
        const serialNumber = startIndex + index + 1;
        return serialNumber;
      },
      enableSorting: false,
      enableColumnOrdering: false,
      enableColumnDragging: false,
      enableColumnFilter: false,
      size: 50,
    },
    {
      accessorKey: 'u_id',
      header: intl.formatMessage({ id: 'booking_id' }),
      enableSorting: false,
      enableColumnOrdering: false,
      enableColumnDragging: false,
      enableColumnFilter: false
    },
   
    {
      accessorKey: 'service_details.name',
      header: intl.formatMessage({ id: 'service_name' }),
      enableSorting: false,
      enableColumnOrdering: false,
      enableColumnDragging: false,
      enableColumnFilter: false
    },
    {
      accessorKey: 'user_details.name',
      header: intl.formatMessage({ id: 'customer_name' }),
      enableSorting: false,
      enableColumnOrdering: false,
      enableColumnDragging: false,
      enableColumnFilter: false
    },
    {
        accessorKey: 'salon_details.salon_name',
        header: intl.formatMessage({ id: 'salon_name' }),
        enableSorting: false,
        enableColumnOrdering: false,
        enableColumnDragging: false,
        enableColumnFilter: false
      },
      {
        accessorKey: 'status',
        header: intl.formatMessage({ id: 'booking_status' }),
        accessorFn: (row: any) => {
          return   getStatus(row?.status)  
         },
        enableSorting: false,
        enableColumnOrdering: false,
        enableColumnDragging: false,
        enableColumnFilter: false
      },
      {
        accessorKey: 'booking_status',
        header: intl.formatMessage({ id: 'booking_type' }),
        accessorFn: (row: any) => {
          return   row?.booking_status == "1" ? intl.formatMessage({ id: 'online' }) : intl.formatMessage({ id: 'offline' })
         },
        enableSorting: false,
        enableColumnOrdering: false,
        enableColumnDragging: false,
        enableColumnFilter: false
      },
      {
        accessorKey: 'amount',
        header: intl.formatMessage({ id: 'booking_price' }),
        enableSorting: false,
        enableColumnOrdering: false,
        enableColumnDragging: false,
        enableColumnFilter: false
      },  
      // {
      //   accessorKey: 'email4',
      //   header: 'Booking Type',
      //   enableSorting: false,
      //   enableColumnOrdering: false,
      //   enableColumnDragging: false,
      //   enableColumnFilter: false
      // },
    {
      accessorKey: 'booking_date',
      header: intl.formatMessage({ id: 'booking_date' }),
      accessorFn: (row: { booking_date: any; }) => getDate(row.booking_date),
      // dateSetting: { locale: "en-GB" },
      size: 100,
      filterVariant: 'date',
      enableSorting: false,
      enableColumnOrdering: false,
      enableColumnDragging: false,
      enableColumnFilter: false,
    },

    {
      accessorKey: 'created_at',
      header: intl.formatMessage({ id: 'created_at' }),
      accessorFn: (row: { created_at: any; }) => getDate(row.created_at),
      // dateSetting: { locale: "en-GB" },
      size: 100,
      filterVariant: 'date',
      enableSorting: false,
      enableColumnOrdering: false,
      enableColumnDragging: false,
      enableColumnFilter: false,
    },

    {
      header: intl.formatMessage({ id: 'action' }),
      size: 30,
      accessorFn: (row: { id: any; }) => <>
        <div className="btn-group action-btn-table">
          <ul style={{ listStyleType: "none", marginLeft: "-24px" }}>
            <span>
              <LinkButtons
                pageLink={`booking-detail`}
                pageID={row?.id}
                showEdit={false}
                showView={true}
                showDelete={false}
              />
            </span>
          </ul>
        </div>
      </>,
      enableSorting: false,
      enableColumnOrdering: false,
      enableColumnDragging: false,
      enableColumnFilter: false
    },
  ];

  useEffect(() => {
    const fetchData = async () => {
      if (!data?.length) {
        setLoading(true);
      } else {
        setIsRefetching(true);
      }
      try {
        const userStatus = DashboardRedirectionStatedata?.data
        // console.log(userStatus)
        let query: any = paginationQuery(
          pagination.pageIndex,
          pagination.pageSize,
          sorting,
          searchValue,
          columnFilters
        );

        query.columnFilters.push({ id: "salon_id", value: userStatus?.salon_id })
        query.columnFilters.push({ id: "user_id", value: userStatus?.user_id })
        query.columnFilters.push({ id: "status", value: userStatus?.status })

        dispatch(DashboardRedirectionAction('RESET'));
        await dispatch(BookingGetAction(query));

      } catch (error) {
        setIsError(true);
        return;
      }
      setIsError(false);
      setLoading(false);
      setIsRefetching(false);
    };
    fetchData();
  }, [
    columnFilters,
    // searchValue,
    pagination.pageIndex,
    pagination.pageSize,
    sorting,
    openSerach
  ]);
  useEffect(() => {
    setData(bookinglist?.data?.data?.rows);
    setRowCount(bookinglist?.data?.data?.count);
  }, [bookinglist?.data]);
 
  const handeldate = (e: any) => {
    const formattedDate = moment(e).format('YYYY-MM-DD');
    setStartDate(formattedDate);
  }

  const handelEnddate = (e: any) => {
    const formattedDate = moment(e).format('YYYY-MM-DD');
    setEndDate(formattedDate)
  }
  const resetSearchfilter = () => {
    setLoading(true)
    setStartDate('')
    setEndDate('')
    setSearchValue('')
    setSearchOther('')
    if (formRef.current) {
      formRef.current.reset();
    }
    const columnFilters = [
      { id: "start_date", value: "" },
      { id: "end_date", value: "" },
      { id: "search", value: "" }

    ]
    setColumnFilters(columnFilters)
  }
  const handleserach = (e: any) => {
    e.preventDefault()
    setLoading(true)
    const columnFilters = [
      { id: "start_date", value: startDate.trim() },
      { id: "end_date", value: endDate.trim() },
      { id: "search", value: searchValue?.trim()},
      { id: "booking_status", value: searchOther?.booking_status?.trim()},
      { id: "booking_type", value: searchOther?.booking_type}
    ]
    setColumnFilters(columnFilters)
  }
  const handleSearchValues = (e: any) => {
    const { name, value } = e.target; 
    setSearchOther((searchOther:any)  => ({...searchOther, [name]: value}));
  }
  
  return (
    <Fragment>
      {(loading || bookinglist?.loading) ? <Spinner /> : ""}


      <PageLayout
        title={<FormattedMessage id="booking_management" />}
        breadcrumbs={{
          secLast: { 'link': '/booking-list', 'name': <FormattedMessage id="booking_management" /> },
        }}
        buttons={[
          { url: '/class-add', className: 'btn btn-primary', text: '+ Add Sponsors', show: false }, // This button will be shown
        ]}
      >
        <form ref={formRef} onSubmit={handleserach}>
         
          <div className='row gy-3 mt-3 mb-4'>
            <div className="col-md-4 col-lg-4 col-xl-3">
              <label><FormattedMessage id="start_date" /></label>
              <DatePicker className="form-control"  placeholderText={intl.formatMessage({ id: 'date_placeholder' })}  value={startDate ? getDateFormatData(startDate) : ''} onChange={(e) => handeldate(e)}  onKeyDown={(e) => e.preventDefault()}/>
            </div>
            <div className="col-md-4 col-lg-4 col-xl-3">
              <label><FormattedMessage id="end_date" /></label>
              <DatePicker className="form-control" placeholderText={intl.formatMessage({ id: 'date_placeholder' })} value={endDate ? getDateFormatData(endDate) : ''} onChange={(e) => handelEnddate(e)} minDate={new Date(startDate)} onKeyDown={(e) => e.preventDefault()} />
            </div>
           
            <div className="col-md-4 col-lg-4 col-xl-3">
              <label><FormattedMessage id="all_bookings" /></label>
              <select className='form-select shadow-none' name="booking_status" id="bookings" onChange={handleSearchValues}>
                <option value="">{intl.formatMessage({ id: 'all_bookings' })}</option>
                <option value="0">{intl.formatMessage({ id: 'upcoming_bookings' })}</option>
                <option value="1">{intl.formatMessage({ id: 'completed_bookings' })}</option>
                <option value="2">{intl.formatMessage({ id: 'cancelled_bookings' })}</option>
                 <option value="0">{intl.formatMessage({ id: 'rescheduled' })}</option> 
                 <option value="3">{intl.formatMessage({ id: 'no_shows_bookings' })}</option>
                </select></div>   

        <div className="col-md-4 col-lg-4 col-xl-3">
              <label><FormattedMessage id="booking_type" /></label>
              <select className='form-select shadow-none' name="booking_type" id="booking" onChange={handleSearchValues}>
                <option value="">{intl.formatMessage({ id: 'all_bookings' })}</option>
                <option value="1">{intl.formatMessage({ id: 'online' })}</option>
                <option value="2">{intl.formatMessage({ id: 'offline' })}</option>
              </select>
            </div> 

            <div className="row gy-3">
            <div className='col-md-6 col-lg-4 col-xl-3'>
              <div className="input-group w-100">
                <div className="input-group">
                  <span className="input-group-text fa-solid fa-magnifying-glass " id="basic-addon1"> <i className="fas fa-search"></i></span>
                  <input type='text' id="saerchId" name='search' className="form-control m-0" placeholder={intl.formatMessage({ id: 'search_by_booking_id' })} onChange={(e)=>setSearchValue(e.target.value)}  />
                </div>
              </div>
            </div>
            <div className="col-6">
              <button className='btn theme-bg text-white me-2'><FormattedMessage id="filter" /></button>
              <button className='btn btn-success' onClick={() => resetSearchfilter()} ><FormattedMessage id="reset" /></button>
            </div>
          </div>
          </div>
        </form>
        {
          data &&
          <MaterialReactTable
            columns={columns}
            data={data}
            enableGlobalFilter={true}

            enableHiding={false}
            enableColumnFilters={false}
            enableDensityToggle={false}
            enableColumnActions={false}
            enableFullScreenToggle={false}
            positionToolbarAlertBanner="top"
            initialState={{ showColumnFilters: false }}
            manualFiltering
            manualPagination
            manualSorting
            muiToolbarAlertBannerProps={isError ? { color: 'error', children: intl.formatMessage({ id: 'error_loading_data' }), } : undefined}
            muiSearchTextFieldProps={{
              placeholder: intl.formatMessage({ id: 'search_from_name' }),
            }}
            onColumnFiltersChange={setColumnFilters}
            onGlobalFilterChange={(value: any) => handleSearch(
              value,
              setIsError,
              setLoading,
              setIsRefetching,
              setSearchValue,
            )
            }
            onPaginationChange={setPagination}
            onSortingChange={setSorting}
            rowCount={rowCount}
            state={{
              columnFilters,
              pagination,
              showAlertBanner: isError,
              showProgressBars: isRefetching,
              sorting,
            }}
          />
        }
        <ToastDefault />
      </PageLayout>
    </Fragment>
  )
}


export default BookingMangementList